module.exports = __webpack_public_path__ + "media/images/webpage/hotels/theme/icon-wavy-brackets-933492b90659cebd16898b5ae355c4d0.svg";